import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EducationCategories, EduPostTypes } from "../../constants";

import * as apiService from "../../service/ApiService";
import { urlId_eduId } from "../../utils/eduUtils";

// will convert/merge the panels in eduReducer into a list of "posts" for the Education page component
const EduPanelPlanner = ({
  posts,
  setPosts,
  categoryIdx,
  hitBottomCount,
  urlPostData,
  setUrlPostData,
  setTargetIdx,
}) => {
  const queryParameters = new URLSearchParams(window.location.search);
  const urlTag = queryParameters.get("tag");
  const urlPostId = queryParameters.get("post");
  const urlRefId = queryParameters.get("ref");
  const dispatch = useDispatch();
  const edu = useSelector((state) => state.edu);

  // if urlPostId is set, load that post
  useEffect(() => {
    console.log("herewid", urlPostData.eduId);
    if (!urlPostData.eduId) return;
    apiService.getEduById(dispatch, { eduId: urlPostData.eduId }, () => {
      setUrlPostData((d) => {
        return { ...d, error: true };
      });
    });
  }, [urlPostData.eduId]);

  // load more of a specific tag, when scrolled to bottom or changing tags
  const loadMore = (skipCount = null) => {
    let postsLength = skipCount !== null ? skipCount : posts.length;
    const tag = categoryIdx === 0 ? "all" : EducationCategories[categoryIdx];
    // don't load posts if we already have the max reported by server
    if (edu.txtPanels && edu.counts[tag] && postsLength >= edu.counts[tag]) {
      console.log("no more posts to load", tag, postsLength, edu.counts[tag]);
      return;
    }
    console.log("loading more", tag, postsLength);
    apiService.getEdu(dispatch, { tag, skipCount: postsLength });
  };
  useEffect(() => {
    if (hitBottomCount === 0) return;
    loadMore();
  }, [hitBottomCount]);

  // actually set the posts
  // also contains the first fetch of panels
  useEffect(() => {
    if (!edu.txtPanels) {
      console.log("fetching panels");
      apiService.getEdu(dispatch, { tag: "all", skipCount: 0 });
      return;
    } else {
      console.log("set edu", edu.txtPanels.length, edu.txtPanels);
    }

    const uniqueTags = new Set();
    edu.txtPanels.forEach((panel) => {
      panel.tags.forEach((tag) => {
        uniqueTags.add(tag);
      });
    });
    console.log("unique tags", uniqueTags);

    let txtPanels;
    if (categoryIdx === 0) {
      txtPanels = edu.txtPanels;
    } else {
      const targetTag = EducationCategories[categoryIdx];
      txtPanels = edu.txtPanels.filter((panel) =>
        panel.tags.includes(targetTag)
      );
    }

    const newPosts = [];
    let txtIdx = 0;
    let vidIdx = 0;
    // while (txtIdx < edu.txtPanels.length || vidIdx < edu.vidPanels.length) {
    while (txtIdx < txtPanels.length) {
      // add 2 of each to stagger. may change in the future
      for (let i = 0; i < 2; i++) {
        if (txtIdx < txtPanels.length) {
          newPosts.push({
            type: EduPostTypes.text,
            data: txtPanels[txtIdx],
          });
          txtIdx++;
        }
      }
      // for (let i = 0; i < 1; i++) {
      //   if (vidIdx < edu.vidPanels.length) {
      //     newPosts.push({
      //       type: EduPostTypes.video,
      //       data: edu.vidPanels[vidIdx],
      //       firstVideo: vidIdx === 0,
      //     });
      //     vidIdx++;
      //   }
      // }
    }
    // load more on category change, if less than 10 posts
    if (newPosts.length < 10) {
      console.log(
        "loading more 1",
        EducationCategories[categoryIdx],
        newPosts.length
      );
      loadMore(newPosts.length);
    }

    console.log("new posts", newPosts.length, newPosts);
    setPosts(newPosts);

    // if urlPostData is being used, and we can find the target id, set the targetIdx
    if (urlPostData && urlPostData.active) {
      const targetIdx = newPosts.findIndex(
        (post) => post.data.eduId === urlId_eduId(urlPostData.eduId)
      );
      console.log("urlPostData search targetIdx", targetIdx);
      if (targetIdx !== -1) {
        setTargetIdx(targetIdx);
      }
    }
  }, [edu.txtPanels, edu.vidPanels, categoryIdx]);
  return (
    <Box
      sx={{
        width: 0,
        height: 0,
        position: "fixed",
      }}
    />
  );
};

export default EduPanelPlanner;
